import { Pipe, PipeTransform, Inject } from '@angular/core';

import * as Tokens from '@shared/core/tokens';

@Pipe({ name: 'cardNo' })
export class CardNoPipe implements PipeTransform {
    constructor(
        @Inject(Tokens.CONFIG_TOKEN) private _config: IConfig
    ) { }

    transform(value: string, char: string = 'X', maxLength: number = this._config.memberCard ? this._config.memberCard.maxLength : 10): string {
        const tempArr: string[] = [];

        while (tempArr.length < maxLength) {
            const index: number = tempArr.length;
            tempArr.push(typeof value === 'string' && value.charAt(index) || char || 'X');
        }

        const dashIndex: number = Math.ceil(tempArr.length / 2);

        tempArr.splice(dashIndex, 0, '-');
        return tempArr.join('');
    }
}
